import React from 'react';
import {NotificationATCContext} from './NotificationATCProvider';
import type {NotificationATCEntry} from './types';

export const useCollisionDetection = () => {
  const context = React.useContext(NotificationATCContext);

  // register should be stable except when the context changes i.e. app or telemetry changes.
  const register = React.useCallback(
    (
      incomingNotification: Omit<
        NotificationATCEntry,
        'id' | 'domRect' | 'domRef'
      > & {
        id?: string;
        domRect?: DOMRect;
      }
    ) => {
      const id = incomingNotification.id || crypto.randomUUID();
      context?.register({
        ...incomingNotification,
        id, // this should follow destructuring of incomingNotification
      });
      return id;
    },
    [context]
  );

  // unregister should be stable except when the context changes i.e. app or telemetry changes.
  const unregister = React.useCallback(
    (id: string) => {
      context?.unregister(id);
    },
    [context]
  );

  return {
    register,
    unregister,
  };
};
